export enum ObjectFieldDataTypes {
    DateTime = "DateTime",
    String = "String",
    Integer = "Integer",
    Text = "Text",
    Decimal = "Decimal",
    PickList = "PickList",
    Boolean = "Boolean",
    Date = "Date",
    Lookup = "Lookup"
}